import { t } from "@i18n";
import IconComponent from "@CubeComponents/icons";
import { fieldTypeToIconMap, type TranslateFn } from "./constant.helper";

import { SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TASK, formCategories } from "@Helpers";

export const getSectionFieldItems = () => [
  {
    text: t("Single Line"),
    id: "single-line",
    icon: "SingleLineTextBox",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Multi Line"),
    id: "multi-line",
    icon: "MultiLineTextBox",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Single Select"),
    id: "single-select",
    icon: "RadioButtonIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Multi Select"),
    id: "multi-select",
    icon: "CheckBoxIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Number"),
    id: "number",
    icon: "NumericIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Look Up"),
    id: "look-up",
    icon: "LookUpIcon",
    items: [
      { text: t("Location"), id: "Location" },
      { text: t("Teams"), id: "Teams" },
    ],
    notInModules: [
      formCategories.projects,
      formCategories.contract,
      formCategories.files,
      formCategories.issues,
      formCategories.model,
      formCategories.mailBox,
      formCategories.transmittal,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Date / Time"),
    id: "date-time",
    icon: "DateTimeIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("User(s)"),
    id: "users",
    icon: "UserProfile",
    notInModules: [
      formCategories.projects,
      formCategories.contract,
      formCategories.files,
      formCategories.issues,
      formCategories.model,
      formCategories.mailBox,
      formCategories.transmittal,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("File Upload"),
    id: "fileUpload",
    icon: "upload",
    notInModules: [
      formCategories.projects,
      formCategories.contract,
      formCategories.files,
      formCategories.issues,
      formCategories.model,
      formCategories.mailBox,
      formCategories.transmittal,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Image"),
    id: "image",
    icon: "image",
    notInModules: [
      formCategories.projects,
      formCategories.contract,
      formCategories.files,
      formCategories.issues,
      formCategories.model,
      formCategories.mailBox,
      formCategories.transmittal,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Geo Location"),
    id: "geoLocation",
    icon: "geoLocation",
    notInModules: [
      formCategories.projects,
      formCategories.contract,
      formCategories.files,
      formCategories.issues,
      formCategories.model,
      formCategories.mailBox,
      formCategories.transmittal,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Url"),
    id: "url",
    icon: "URL",
    notInModules: [formCategories.files, formCategories.mailBox, formCategories.assetsInstance, formCategories.assets],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Formula"),
    id: "formula",
    icon: "Formula",
    notInModules: [formCategories.files, formCategories.mailBox, formCategories.assetsInstance, formCategories.assets],
    allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Concatenate"),
    id: "concatenate",
    icon: "merge",
    notInModules: [formCategories.files, formCategories.assets, formCategories.assetsInstance],
    allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Auto Number"),
    id: "autoNumber",
    icon: "autoNumber",
    notInModules: [
      formCategories.issues,
      formCategories.files,
      formCategories.assetsInstance,
      formCategories.assets,
      formCategories.projects,
      formCategories.contract,
      formCategories.model,
      formCategories.reviews,
      formCategories.transmittal,
      formCategories.drawing,
    ],
    allowIn: [SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
];

const COMMON_SECTION_PROPS = [
  { text: t("Add Section To Library"), id: "add_to_section_library" },
  { text: t("Edit Section Title"), id: "edit_section_header" },
  { text: t("Delete Section"), id: "delete_section" },
];

export const getNormalSectionPropBtns = () => COMMON_SECTION_PROPS;

export const getPresetSectionPropBtns = () => [
  {
    text: t("Delete Section"),
    id: "delete_section",
  },
];
export const getTableSectionPropBtns = () => [
  ...COMMON_SECTION_PROPS,
  {
    text: t("Configure"),
    id: "configure",
  },
];

export const getSideBarMenuItems = () => [
  {
    text: t("Close Side Bar"),
    id: "closeSideBar",
  },
];

const getValidationValue = (
  allowAttachments: boolean,
  allowPredifinedVal: boolean,
  resourceType = "",
  allowMandatory = true,
) => {
  const isMailbox = resourceType === formCategories.mailBox;
  return [
    ...(allowMandatory
      ? [
          {
            name: t("Mandatory"),
            id: "isMandatory",
            allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
          },
        ]
      : []),
    ...(allowAttachments
      ? [
          {
            name: t("Require Attachment(s)"),
            id: "requireAttachments",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
        ]
      : []),
    ...(allowPredifinedVal
      ? [
          {
            name: t("Allow Predefine Value"),
            id: "allowPredefinedVal",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
          {
            name: t("Allow editing of predefined value during form filling"),
            id: "allowEditingOfPredefinedVal",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
        ]
      : []),
    ...(isMailbox
      ? [
          {
            name: t("Editable In form"),
            id: "editableInForm",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
          {
            name: t("Is Metadata"),
            id: "isMetadata",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
        ]
      : []),
  ];
};

const getConfigurationDisplayValues = () => {
  return [
    {
      name: t("Text"),
      id: "text",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
    {
      name: t("Button"),
      id: "button",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
  ];
};

const getConfigurationOpenInValue = () => {
  return [
    {
      name: t("New tab"),
      id: "newTab",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
    {
      name: t("Same tab"),
      id: "sameTab",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
    {
      name: t("Pop-up"),
      id: "popUp",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
  ];
};

const getUrlFieldValues = () => {
  return [
    {
      name: t("Display As"),
      key: "displayAs",
      id: "displayAs",
      defaultValue: "text",
      values: getConfigurationDisplayValues(),
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
    {
      name: t("Open In"),
      key: "openIn",
      id: "openIn",
      defaultValue: "newTab",
      values: getConfigurationOpenInValue(),
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
  ];
};
const COMMON_DETAIL_VALUE_VALIDATION = (
  allowAttachments = false,
  allowPredifinedVal = false,
  resourceType = "",
  allowMandatory = true,
) => [
  {
    name: t("Details"),
    id: "details",
    icon: "details",
  },
  {
    name: t("Value"),
    id: "value",
    icon: "ValueIcon",
  },
  {
    name: t("Validation"),
    id: "validation",
    icon: "ValidationIcon",
    values: getValidationValue(allowAttachments, allowPredifinedVal, resourceType, allowMandatory),
  },
];

export const getFormSideBarDataTemplate = (allowAttachments = false, resourceType = "") => ({
  "single-select": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  "multi-select": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  "single-line": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  "multi-line": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  "date-time": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  fileUpload: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, false, resourceType),
  image: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  geoLocation: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, false, resourceType),
  number: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, true, resourceType),
  formula: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, false, "", false),
  // Concatenate & Auto Number are system-derived (never user-editable), so mandatory stays
  // disabled. Passing resourceType through surfaces the mailbox-only "Editable In form" /
  // "Is Metadata" toggles (CP-1243) that control where the field is visible.
  concatenate: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, false, resourceType, false),
  autoNumber: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments, false, resourceType, false),
  url: [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Configuration"),
      id: "configuration",
      icon: "Slider",
      values: getUrlFieldValues(),
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: getValidationValue(allowAttachments, true, resourceType),
    },
  ],
  "look-up": [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: getValidationValue(allowAttachments, false, resourceType),
    },
  ],
  users: [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Allow only current Logged in user"),
          id: "onlyCurrentUser",
          allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
        },
        ...(allowAttachments
          ? [
              {
                name: t("Require Attachment(s)"),
                id: "requireAttachments",
                allowIn: [SECTION_TYPE_BLANK_SECTION],
              },
            ]
          : []),
        ...(resourceType === formCategories.mailBox
          ? [
              {
                name: t("Editable In form"),
                id: "editableInForm",
                allowIn: [SECTION_TYPE_BLANK_SECTION],
              },
              {
                name: t("Is Metadata"),
                id: "isMetadata",
                allowIn: [SECTION_TYPE_BLANK_SECTION],
              },
            ]
          : []),
      ],
    },
  ],
  actualStartDate: [
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  actualEndDate: [
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  progress: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  remDuration: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  tableSection: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Allow adding new rows during form filling"),
          id: "allowNewRowAddInForm",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Predefine row values"),
          id: "allowPreDefineRowValues",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Allow editing of predefined row values during form filling"),
          id: "allowEditPreDefineRowInForm",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
      ],
    },
  ],
});

export const templateEditCases = {
  EDIT_SECTION_HEADING: "editSectionHeading",
  DELETE_SECTION: "deleteSection",
  CHANGE_SECTION_SEQUENCE: "changeSectionSequence",
  CONFIGURE_SECTION: "configureSection",

  EDIT_QUESTION: "editQuestion",
  ADD_QUESTION: "addQuestion",
  DELETE_QUESTION: "deleteQuestion",
  CONFIGURE_QUESTION: "configureQuestion",
  CHANGE_QUESTION_SEQUENCE: "changeQuestionSequence",
};

export const lookUpType = ["Location", "Teams"];

export const fileTypesDataSource = [
  { name: "Pdf", value: "application/pdf" },
  { name: "Jpg", value: "image/jpg" },
  { name: "Png", value: "image/png" },
  { name: "Jpeg", value: "image/jpeg" },
];

export const imageTypesDataSource = [
  { name: "Jpg", value: "image/jpg" },
  { name: "Png", value: "image/png" },
  { name: "Jpeg", value: "image/jpeg" },
];

export const getIconFromFieldType = (fieldType: string) => {
  const iconName = fieldTypeToIconMap[fieldType];

  if (iconName) {
    return <IconComponent name={iconName} width="1.5rem" height="1.5rem" />;
  }
  return "";
};

export const getFieldTypeToHeadingMap = (t: TranslateFn) => ({
  "single-line": t("Single Line"),
  "multi-line": t("Multi Line"),
  "single-select": t("Single Select"),
  "multi-select": t("Multi Select"),
  "date-time": t("Date / Time"),
  "look-up": t("Look Up"),
  "look-up-location": t("Look Up - Location"),
  "look-up-teams": t("Look Up - Teams"),
  number: t("Number"),
  users: t("User(s)"),
  fileUpload: t("File Upload"),
  image: t("Image"),
  url: t("Url"),
  geoLocation: t("Geo Location"),
  actualStartDate: t("Actual Start Date"),
  actualEndDate: t("Actual End Date"),
  progress: t("Progress %"),
  remDuration: t("Remaining Duration"),
  formula: t("Formula"),
  concatenate: t("Concatenate"),
  autoNumber: t("Auto Number"),
});
